import { InfaceEnv, getModuleApi } from '@inface-sdk/common';
import './web-push';
if (InfaceEnv.isBrowser()) {
  window._startWebPush = getModuleApi('web-push').startWebPush;
  window.startWebPush = window._startWebPush;
  window._stopWebPush = getModuleApi('web-push').stopWebPush;
  window.stopWebPush = window._stopWebPush;
  window._webPushEvents = getModuleApi('web-push').webPushEvents;
  window.webPushEvents = window._webPushEvents;
  window._ackToyPushMessage = getModuleApi('web-push').ackToyPushMessage;
  window.ackToyPushMessage = window._ackToyPushMessage;
  window._infaceWebPush = getModuleApi('web-push').webPush;
  window._infaceWebPushTokenBuilder = getModuleApi('web-push').TokenBuilder;
  window.InfaceWebPush = window._infaceWebPush;
  window.InfaceTokenBuilder = window._infaceWebPushTokenBuilder;
  window._getModuleApi = getModuleApi;
  window.inface = window.inface || {};
  inface.push = {
    startWebPush: window._startWebPush,
    stopWebPush: window._stopWebPush,
    ackToyPushMessage: window._ackToyPushMessage,
    events: window._webPushEvents()
  };
}
export default window.InfaceWebPush;